import React from "react"
import { Button, Panel, CopyButton } from "dash-styled"
import { useAsyncCommand } from "../../../../../../../Hooks/useAsyncCommand"
import { ReactComponent as IconTrash } from "icons/lib/trash.svg"

interface KeysModalRowProps {
    apiKey: string
    onDelete: () => Promise<void>
}

export const KeysModalRow = ({ apiKey, onDelete }: KeysModalRowProps) => {
    const deletion = useAsyncCommand(onDelete)

    return (
        <Panel size="sm" className="flex items-center mb-4">
            <div className="text-sm font-mono flex-grow">{apiKey}</div>
            <CopyButton className="ml-8 mr-2" value={apiKey} variant="normal" />
            <Button
                variant="contained2"
                color="white"
                size="xs"
                disabled={deletion.isProcessing}
                onClick={deletion.perform}
            >
                <IconTrash className="w-5 h-5 text-black text-opacity-50" />
            </Button>
        </Panel>
    )
}
